import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { environment } from "../../../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-student-userwishlist-create",
  templateUrl: "./student-userwishlist-create.component.html",
  styleUrls: ["./student-userwishlist-create.component.scss"],
})
export class StudentUserwishlistCreateComponent implements OnInit {
  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;
  isShown: boolean = false;
  userdata = [];
  colleges = [];
  courses = [];

  constructor(
    private ActivatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit() {
    let role = localStorage.getItem("userRole");
    let user = localStorage.getItem("userId");

    this.action = "Submit";
    
    // Load initial data
    this.loadColleges();
    this.loadCourses();
    this.loadUserData();

    this.ActivatedRoute.params.subscribe((params) => {
      let id = params["id"];
      if (id) {
        this.loadWishlistData(id, role, user);
      }
    });

    this.initializeForm();
  }

  initializeForm() {
    this.Form = this.formBuilder.group({
      college: ["", [Validators.required]],
      user_id: ["", [Validators.required]],
      course: ["", [Validators.required]],
      _id: [""],
    });
  }

  loadColleges() {
    this.http
      .get<any>(`${environment.apiUrl}/college/`, {
        headers: this.getHeaders()
      })
      .subscribe(
        (data) => {
          if (data.message == "Logged Out!") {
            this.router.navigateByUrl("/auth/login");
            return;
          }
          this.colleges = data.results || [];
        },
        (err: HttpErrorResponse) => {
          console.error("Error loading colleges:", err);
        }
      );
  }

  loadCourses() {
    this.http
      .get<any>(`${environment.apiUrl}/course/`, {
        headers: this.getHeaders()
      })
      .subscribe(
        (data) => {
          if (data.message == "Logged Out!") {
            this.router.navigateByUrl("/auth/login");
            return;
          }
          this.courses = data.results || [];
        },
        (err: HttpErrorResponse) => {
          console.error("Error loading courses:", err);
        }
      );
  }

  loadUserData() {
    this.http
      .get<any>(`${environment.apiUrl}/userdata/`, {
        headers: this.getHeaders()
      })
      .subscribe(
        (data) => {
          if (data.message == "Logged Out!") {
            this.router.navigateByUrl("/auth/login");
            return;
          }
          this.userdata = data.results || [];
        },
        (err: HttpErrorResponse) => {
          console.error("Error loading user data:", err);
        }
      );
  }

  loadWishlistData(id: string, role: string, user: string) {
    this.http
      .get<any>(`${environment.apiUrl}/userwishlist/${id}`, {
        headers: this.getHeaders()
      })
      .subscribe(
        (data) => {
          if (data.message == "Logged Out!") {
            this.router.navigateByUrl("/auth/login");
            return;
          }
          
          if (data.data != "") {
            if (role != "super-admin" && data.data.userid != user) {
              this.router.navigateByUrl("/student-details/student-userwishlist-list");
              return;
            }
            
            this.action = "Update";
            this.Form.patchValue({
              _id: data.data._id,
              college: data.data.college,
              user_id: data.data.user_id,
              course: data.data.course,
            });
          }
        },
        (err: HttpErrorResponse) => {
          console.error("Error loading wishlist data:", err);
        }
      );
  }

  get f() {
    return this.Form.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    const data = {
      college: this.Form.value.college, // This should be a MongoDB ID
      user_id: this.Form.value.user_id, // Changed from userdata to user_id
      course: this.Form.value.course,   // Added course field
    };

    if (this.action == "Submit") {
      this.createWishlist(data);
    } else {
      data['_id'] = this.Form.value._id;
      this.updateWishlist(data);
    }
  }

  createWishlist(data: any) {
    this.http
      .post<any>(`${environment.apiUrl}/userwishlist/`, data, {
        headers: this.getHeaders()
      })
      .subscribe(
        (res) => {
          this.handleResponse(res);
        },
        (err: HttpErrorResponse) => {
          this.handleError(err);
        }
      );
  }

  updateWishlist(data: any) {
    this.http
      .put<any>(`${environment.apiUrl}/userwishlist/`, data, {
        headers: this.getHeaders()
      })
      .subscribe(
        (res) => {
          this.handleResponse(res);
        },
        (err: HttpErrorResponse) => {
          this.handleError(err);
        }
      );
  }

  private getHeaders() {
    return {
      Userinfo: JSON.stringify({
        _id: localStorage.getItem("adminSess"),
        role: localStorage.getItem("userRole"),
      }),
    };
  }

  private handleResponse(res: any) {
    if (res.message == "Logged Out!") {
      this.router.navigateByUrl("/auth/login");
      return;
    }
    
    if (res.status == "500") {
      this.showMessage(res.message, "danger");
    } else {
      this.showMessage(
        this.action === "Submit" ? "Successfully Added" : "Successfully Updated", 
        "success"
      );
      this.router.navigateByUrl("/student-details/student-userwishlist-list");
    }
  }

  private handleError(err: HttpErrorResponse) {
    console.error("API Error:", err);
    this.showMessage("An error occurred. Please try again.", "danger");
  }

  private showMessage(message: string, type: string) {
    this.message = message;
    this.class = type === "success" 
      ? "btn-success rounded px-1 py-1" 
      : "btn-danger rounded px-1 py-1";
    
    window.scrollTo(0, 0);
    setTimeout(() => {
      this.message = null;
    }, 3000);
  }
}